export default __webpack_public_path__ + "static/media/snowmobile_light.3f425247.png";